export { MagnetCTOPage } from './MagnetCTOPage';
